import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { REACTION_MAP } from "@/lib/reactions";

/**
 * One reactor in the viewer. The whole row navigates to the person's Personal Profile;
 * every optional line (role · company / headline, location) simply isn't rendered when the
 * data doesn't exist — no placeholders, no dangling separators.
 */
export function ReactorRow({ person, onNavigate }) {
  const r = REACTION_MAP[person.emoji];
  const inner = (
    <>
      <Avatar className="h-10 w-10 shrink-0">
        {person.headshot_url && <AvatarImage src={fileUrl(person.headshot_url)} className="object-cover" />}
        <AvatarFallback className="bg-teal-50 text-teal-700">{(person.display_name || "M")[0]}</AvatarFallback>
      </Avatar>
      <span className="min-w-0 flex-1">
        <span className="block truncate font-[600] text-foreground">{person.display_name}</span>
        {person.subtitle && <span className="block truncate text-sm text-muted-foreground">{person.subtitle}</span>}
        {person.location_text && <span className="block truncate text-sm text-muted-foreground">{person.location_text}</span>}
      </span>
      {r && (
        <span className="shrink-0 text-lg leading-none" role="img" aria-label={r.label} title={r.label}>{r.emoji}</span>
      )}
    </>
  );

  const cls = "flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left transition-colors hover:bg-secondary/60";
  if (!person.slug) {
    return <div className={cls} data-testid={`reactor-row-${person.user_id}`}>{inner}</div>;
  }
  return (
    <Link
      to={`/p/${person.slug}`}
      className={cls}
      onClick={(e) => { e.stopPropagation(); onNavigate?.(); }}
      data-testid={`reactor-row-${person.user_id}`}
    >
      {inner}
    </Link>
  );
}

export default ReactorRow;
